export function calcKagetecAccordFactor(percent: number, workTime: number) {
    // percent is range from 0 - 1
    // workTime is in ms
    return percent * 100 * (workTime / 1000 / 60 / 60);
}
export function calcKagetecAccordStundenLohn(lSum: number, faktorSum: number, percent: number) {
    // percent is range from 0 - 1
    return (lSum / faktorSum) * (percent * 100);
}
